import {
  PLATFORM_COLORS,
  PLATFORM_ICONS,
  additonalPlatformIcons,
} from "../../../config/icons";

export const PlatformIcon: React.FC<any> = ({
  platform,
  active,
  key,
  onClick,
}: any) => {
  return (
    <div
      onClick={onClick}
      key={key}
      className="border border-secondary d-flex flex-column align-items-center justify-content-between text-center py-5 px-5 rounded cursor-pointer w-70px shadow"
    >
      <div>
        <i
          className={PLATFORM_ICONS[platform] + " fs-2x"}
          style={{
            color: active ? PLATFORM_COLORS[platform] : null,
          }}
        ></i>
      </div>

      <div
        className="position-absolute"
        style={{ marginLeft: "40px", marginTop: "25px" }}
      >
        {additonalPlatformIcons[platform] && (
          <i className={additonalPlatformIcons[platform]}></i>
        )}
      </div>
    </div>
  );
};

export const SmallPlatformIcon: React.FC<any> = ({
  platform,
  active,
  key,
  onClick,
}: any) => {
  return (
    <div
      key={key}
      onClick={onClick}
      className={` ${
        additonalPlatformIcons[platform] ? "pe-4" : ""
      } platformSearchBox border d-flex flex-column align-items-center text-center p-2  rounded w-40px h-40px m-1 cursor-pointer border-secondary`}
    >
      <div>
        <i
          className={PLATFORM_ICONS[platform] + " fs-2"}
          style={{ color: active ? PLATFORM_COLORS[platform] : null }}
        ></i>
      </div>

      {additonalPlatformIcons[platform] && (
        <div
          className="position-absolute"
          style={{ marginLeft: 25, marginTop: 10 }}
        >
          <i className={`${additonalPlatformIcons[platform]} fs-8`}></i>
        </div>
      )}
    </div>
  );
};
